<template>
 <div :class="cardClasses">
   <CCard class="shadow" borderColor="primary" body-wrapper>
      <CRow v-if="plan" class="tarifas d-flex flex-wrap justify-content-between align-items-center mt-2 mb-1 info-my-rent">
        <CCol class="planCard mr-1 mb-2" lg="12" md="12" xl="12" xxl="7">

          <h5 class="text-primary mb-3">{{ plan.plan.name }}</h5>

          <!-- <p v-if="plan.plan.id != 1" class="mb-0">
             <span> Elige el día y la hora que se adapte mejor a ti</span>
          </p> -->

          <!-- v-if="[4, 8, 9].includes(plan.plan.id)" -->
          <div v-if="plan.plan.id !== 1">
            <!-- <p v-if="plan.plan.plan_detail.duration">Duracion {{plan.plan.plan_detail.duration}} días</p> -->

            <p >
              {{ getDesciption(plan.plan.id) }}
            </p>
            <!-- <span v-if="plan.plan.plan_detail.start_day"> Del {{ plan.plan.plan_detail.start_day }} a </span> <span v-else>De </span> las {{ plan.plan.plan_detail.start_hour }} h
            <span v-if="plan.plan.plan_detail.end_day"> al {{ plan.plan.plan_detail.end_day}}</span> a las {{ plan.plan.plan_detail.end_hour }} h -->
          </div>

          <!-- <p v-if="![ 4, 8, 9].includes(plan.plan.id) && plan.plan.id != 1" >
            <span> Elige el día de inicio y la hora que se adapte mejor a ti</span>
          </p> -->

          <div v-if="plan.plan.id === 1" class="mb-0">
            {{plan.plan.description}}

            <p>
              {{ getDesciption(plan.plan.id) }}

            </p>

          </div>

          <p class="mb-0"><strong>Precio: </strong>

            <span v-if="plan.plan.id === 11">
              A definir por los días seleccionados
            </span>

            <span v-else>

              <span v-if="plan.plan.id !== 9 && plan.plan.id !== 1">
                {{ plan.amount | toFixedNoRounding }} €
              </span>

              <span v-if="plan.plan.id == 1">
                {{plan.price}} € por Minuto,
                 {{ getHourPrice(plan.price) }}€ por Hora. 

            <br><strong>Precio Máximo 24h: </strong> {{ maxDailyAmount }} €<br><br>
              <!-- <span style="font-weight: 700; color: #9fc83b">
              <br>Precio máxim 24h {{ maxDailyAmount }} € </span> -->
              </span>

              <span v-else-if="plan.plan.id !== 3">  / {{plan.price}} € por Hora</span>


            </span>
           </p>
           
          <p v-if="plan.plan.id !== 1" style="font-size: small;" class="text-primary mt-2 mb-0">Pulsa en Contratar y selecciona los días del plan</p>
          <small v-if="plan.plan.id === 1" class="mt-4 text-primary">* Plan activo al registrarte</small>
          <p v-if="NOACCESS" style="font-size: small;" class="text-danger mt-2 mb-0">Es necesario añadir un teléfono y tarjeta de crédito para disfrutar de los servicios.</p>
        </CCol>
        <CCol class="planCard button" md="4">


        <!-- :disabled="NOACCESS" -->
        <CButton v-if="plan && plan.plan.id != 1" @click="$emit('planSelected', plan)"  color="success" shape="pill" class="px-4">Contratar</CButton>
        </CCol>
      </CRow>
      <CRow class="d-flex" v-else>
        <CCol class="planCard">
          <p class="text-left ">Llama al  {{ MIMOTO_PHONE.label }} para informarte sobre las tarifas o consulta en <a class="card-link" href="https://mimotoparking.com/">https://mimotoparking.com/</a></p>
        </CCol>
      </CRow>
   </CCard>
 </div>
</template>

<script>

import { getPlanDetailHours } from '@/app/shared/utils/utils';

import {MIMOTO_PHONE, MIMOTO_WHATSAPP, MIMOTO_MAIL} from '@/config';


export default {
  name: 'PlanCard',
  props: {
    plan: { type: Object },
    cardClasses: { type: String, default: ""},
    maxDailyAmount: { default: ""},
    NOACCESS: { type: Boolean, default: false }
  }, 
  data() {
    return {
      MIMOTO_PHONE: MIMOTO_PHONE,
      MIMOTO_WHATSAPP: MIMOTO_WHATSAPP,
      MIMOTO_MAIL: MIMOTO_MAIL

    }
  },
  methods :{
    getDesciption(planId) {
      return getPlanDetailHours(planId);
    },
    getHourPrice(minutePrice) {
      return (minutePrice * 60).toFixed(2);
    },
  
  }

}
</script>

<style lang="scss" scoped>
// .tarifas {
//   @media screen and (max-width: 1450px) {
//     flex-direction: column !important;
//     align-content: flex-start;
//   }
// }
// .planCard {
//   width: auto !important;
//     @media screen and (max-width: 1450px) { //619
//       width: 100% !important;
//   }
// }

.button {
  // @media screen and (max-width: 1450px) {
  //     margin-top: 1.25rem;
  //     align-self: flex-start;
  // }
  .btn {
    float: right;
      @media screen and (max-width: 1400px) and  (min-width: 768px) {
      margin-top: 1rem;  
      float: none;
    }
    @media screen and (max-width: 767px) {
      margin-top: 1rem;
      float: none;
    }
  }
}
</style>
